import { Identifiable, CostProfile } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeCostProfile(httpClient: HttpClient) {
  return (costProfile: Identifiable<CostProfile>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/costProfiles/${costProfile.uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeCostProfile };
